import { FC, FormEvent, useState } from 'react'
import styled from 'styled-components'
import { NormalFormPasswordField } from '../molecules'
import { Button, RowSpacer } from '../atoms'
import { useUserLanguage } from '@/customHooks/useUserLanguage'
import textsData from '@/textData/ResetPasswordTexts.json'
import { ResetPasswordMutation, ResponseType, useResetPasswordMutation } from '@/graphql/generated'
import { useLocation, useNavigate } from 'react-router'
import { FetchResult } from '@apollo/client'
import { pathURL } from '@/components/constants/urls'
import { useErrorHandlerContext, useOpeningElementsControllerContext } from '@/customHooks'
import { Col, Row } from 'react-grid-system'
import ReactPasswordChecklist from 'react-password-checklist'
import { WarnText } from '../atoms/WarnText'

type PasswordDataProps = {
  password1: string | null
  password2: string | null
}
const emptyPasswordData: PasswordDataProps  = {
  password1: null,
  password2: null
}

const FormContainer = styled.form`
  margin: 0 auto;
  padding: 20px;
  width: 80%;
`;

export const ResetPasswordForm: FC = () => {
  const [passwordData, setPasswordData] = useState<PasswordDataProps>(emptyPasswordData)
  const [isPasswordValid, setIsPasswordValid] = useState(false);

  const [isWarnTextHidden, setIsWarnTextHidden] = useState(true)

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()

  const [resetPasswordAction, { loading }] = useResetPasswordMutation()

  const { open: errorHandle } = useErrorHandlerContext()

  const navigate = useNavigate()

  const location = useLocation()

  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.resetPassword: textsData.en.resetPassword
  
  const onSuccessHandle = (response: FetchResult<ResetPasswordMutation>) => {
    const resetPasswordResponse = response.data?.resetPassword;
    if (!resetPasswordResponse) return 

    if (resetPasswordResponse.responseType === ResponseType.Success) {
      confirmDialogModalOpen({...texts.succesfully})
      navigate(`/${pathURL.LOGIN}`)
    } else {
      setIsWarnTextHidden(false)
    }
    
  }

  // Manejador de envío del formulario
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Evita el comportamiento predeterminado del formulario

    if (!passwordData.password1 || !passwordData.password2) return
    
    resetPasswordAction({ variables: {
      otpCode: location.state?.otpCode ?? 0,
      newPassword: passwordData.password1
    }})
      .then(onSuccessHandle)
      .catch(errorHandle)
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <Row>
        <Col>
          <NormalFormPasswordField
            label={texts.password1}
            name="password"
            placeholder={texts.password1Placeholder}
            onChange={(value) => setPasswordData((prev) => ({ ...prev, password1: value}))}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormPasswordField
            label={texts.password1}
            name="password"
            placeholder={texts.password1Placeholder}
            onChange={(value) => setPasswordData((prev) => ({ ...prev, password2: value}))}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <ReactPasswordChecklist
            rules={["minLength","specialChar","number","capital","match"]}
				    minLength={5}
				    value={passwordData.password1 ?? ''}
				    valueAgain={passwordData.password2 ?? ''}
				    onChange={(value) => setIsPasswordValid(value)}
          />
        </Col>
      </Row>
      <RowSpacer height={3} />
      <Row>
        <Col>
          <Button
            submit
            upperCased
            isLoading={loading}
            disabled={!isPasswordValid}
          >
            {texts.button}
          </Button>
        </Col>
      </Row>
      <RowSpacer height={1} />
      <Row>
        <Col>
          <WarnText
            text='A problem ocurr with password reseting, please try again entire proccess'
            hidden={isWarnTextHidden}
          />
        </Col>
      </Row>
    </FormContainer>
  )
/* 
  return (
    <FormContainer onSubmit={handleSubmit}>
      <FormPasswordField
        name="password"
        placeholder={texts.password1Placeholder}
        action={(value) => setPasswordData((prev) => ({ ...prev, password1: value }))}
      >
        {texts.password1}
      </FormPasswordField>
      <FormPasswordField
        name="password"
        placeholder={texts.password2Placeholder}
        action={(value) => setPasswordData((prev) => ({ ...prev, password2: value }))}
      >
        {texts.password2}
      </FormPasswordField>
      <WarnText $isHidden={!isWarnTextHidden}>{texts.warn}</WarnText>
      <br />
      <Button submit upperCased isLoading={loading}>{texts.button}</Button>
    </FormContainer>
  );
   */
};
